/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Why_Lock_ValueInputs */

const en_landing_why_lock_value = /** @type {(inputs: Landing_Why_Lock_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pixel Lock`)
};

const zh_landing_why_lock_value = /** @type {(inputs: Landing_Why_Lock_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`像素锁定`)
};

/**
* | output |
* | --- |
* | "Pixel Lock" |
*
* @param {Landing_Why_Lock_ValueInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_why_lock_value = /** @type {((inputs?: Landing_Why_Lock_ValueInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Why_Lock_ValueInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_why_lock_value(inputs)
	return zh_landing_why_lock_value(inputs)
});
export { landing_why_lock_value as "landing.why.lock_value" }